import PropTypes from 'prop-types';
import React from 'react';

const Avatar = ({ size = 'sm', src, subtitle, title }) => {
	const sizes = {
		lg: { subtitle_size: 'sm', thumb: 'thumb-lg', title_size: 'lg' },
		md: { subtitle_size: 'sm', thumb: 'thumb-md', title_size: 'base' },
		sm: { subtitle_size: 'xs', thumb: 'thumb-sm', title_size: 'sm' },
	};

	return (
		<div className="avatar d-flex align-items-center gap-3 mt-2">
			<img className={`${sizes[size].thumb} rounded-pill`} src={src} />
			{title && (
				<div className="avatar-content text-white">
					<h3
						className={`avatar-title mb-0  fw-800  ${sizes[size].title_size}`}
					>
						{title}
					</h3>
					{subtitle && (
						<p className={`avatar-subtitle mb-0 ${sizes[size].subtitle_size}`}>
							{subtitle}
						</p>
					)}
				</div>
			)}
		</div>
	);
};

Avatar.propTypes = {
	size: PropTypes.string,
	src: PropTypes.string,
	subtitle: PropTypes.string,
	title: PropTypes.string,
};

export default Avatar;
